import script from "./GroupLoadingNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupLoadingNotice.vue?vue&type=script&setup=true&lang=js"

import "./GroupLoadingNotice.vue?vue&type=style&index=0&id=a57641e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a57641e8"]])

export default __exports__